export default __webpack_public_path__ + "static/media/carrosel06.6c81f7e8.png";